// setFcmToken.js
'use strict';

import mergeMeData from '../action/mergeMeData.js';
import { initFcm, getFcmMessaging, getFcmToken } from '../resource/fcm.js';
import { hasServiceWorker } from '../serviceWorker/helpers.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Bind fcm
 * @kind action
 * @return {Promise} Action promise.
 */
const setFcmToken = () => async (dispatch, getState) => {
  const state = getState();
  const isAuthed = !!getMeData(state, 'id');
  const permission = getOperationData(state, ['permission'], 'notification');

  if (
    !isAuthed ||
    !window.PushManager ||
    permission !== 'granted' ||
    !hasServiceWorker
  )
    return;

  try {
    if (!getFcmMessaging()) await initFcm();

    const fcmToken = await getFcmToken();
    if (fcmToken) {
      dispatch(mergeMeData({ field: 'fcmToken', value: fcmToken }));
    }
    // eslint-disable-next-line no-empty
  } catch (error) {}
};

export default setFcmToken;
